/**
 * Initializes the configuration page
 */
export default function InitConfigurationPage() {
	const frameElement = document.getElementById("config-frame");
	if (!frameElement) return;

	frameElement.addEventListener("load", () => {
		configurationLoaded(frameElement);
	});
}

function configurationLoaded(iframe) {
	const frame = window.frames[0];
	const mainContainer = frame.document.getElementById("main");
	if (!mainContainer) return;
	var iframeContentHeight = mainContainer.offsetHeight;

	frame.document.body.classList.add("embedded");

	// constantly update iframe height to fit content
	setInterval(function () {
		if (mainContainer.offsetHeight != iframeContentHeight) {
			iframeContentHeight = mainContainer.offsetHeight;
			iframe.style.height = iframeContentHeight + "px";
		}
	}, 100);
	document.getElementById("loading-overlay").classList.add("hidden");
}
